type QueryValue = string | number | boolean | null | undefined | (string | number)[];

/**
 * Serializes a params object into a query string using repeated keys for arrays
 * (`categories=1&categories=2`), NOT bracketed keys (`categories[]=1`). This is the
 * format the backend form-options endpoints expect. `null`/`undefined` values are omitted.
 *
 * Returns the query string WITHOUT a leading `?` (empty string when there's nothing to send).
 */
export const buildQueryString = (params: Record<string, QueryValue>): string => {
	const search = new URLSearchParams();

	Object.entries(params).forEach(([key, value]) => {
		if (value == null) return;
		if (Array.isArray(value)) {
			value.forEach((v) => search.append(key, String(v)));
			return;
		}
		search.set(key, String(value));
	});

	return search.toString();
};
